import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppState } from "../store/definitions";
import { AttachFileDropArea } from "./AttachFileDropArea";
import { Box } from "@twilio-paste/core/box";
import { ConversationEnded } from "./ConversationEnded";
import { Header } from "./Header";
import { MessageInput } from "./MessageInput";
import { MessageList } from "./MessageList";
import { NotificationBar } from "./NotificationBar";
import { Text } from "@twilio-paste/core/text";
import { notifications } from "../notifications";
import { removeNotification } from "../store/actions/genericActions";

export const MessagingCanvasPhase = () => {
  const dispatch = useDispatch();
  const conversationState = useSelector(
    (state: AppState) => state.chat.conversationState
  );

  useEffect(() => {
    dispatch(
      removeNotification(notifications.failedToInitSessionNotification("ds").id)
    );
  }, [dispatch]);

  const Wrapper =
    conversationState === "active" ? AttachFileDropArea : Fragment;

  return (
    <Wrapper>
      <Header />
      <NotificationBar />
      <Box
        as="main"
        padding="space40"
        backgroundColor="colorBackgroundBody"
        data-test="messaging-canvas"
        display="flex"
        flexDirection="column"
        height="100%"
        minHeight="0"
      >
        <Box flex="1 1 0%" minHeight="0" display="flex" flexDirection="column">
          <MessageList />
        </Box>
        {conversationState === "active" ? (
          <MessageInput />
        ) : (
          <ConversationEnded />
        )}
      </Box>
    </Wrapper>
  );
};
